// =============================================================================
//  Copyright : 2019 semantics GmbH
//  Date      : $Date: 2026-02-04 13:09:31 +0100 (Wed, 04 Feb 2026) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 160290 $
//  Purpose   : tests package, only included in dev build (TODO)
// =============================================================================
export const parts = true;
//~ import * as reducers from './reducers'
//~ export {reducers}
import * as actions from './actions';
export { actions };
import * as views from './views';
export { views };
